var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-content--container"},[_c('iframe',{attrs:{"src":"https://app.powerbi.com/view?r=eyJrIjoiN2E5MzJjOTMtYzQ3Ni00NDMwLWE0ODEtNDY2NjBiNzQwNzdkIiwidCI6IjE3ZmM0OGQ0LTZkNDgtNDVmNy1iZjJiLWUzNjc4MjM5OTc1ZiIsImMiOjh9&embedImagePlaceholder=true&pageName=ReportSectiond949bf72657dc30cdb70","frameborder":"0","height":"100%","width":"100%"}})])
}]

export { render, staticRenderFns }